<script>
  import { onMount } from 'svelte'
  import { db } from '../util.js'
  import BellyBand from '../BellyBand.svelte'

  let content = 'Loading...'
  let title = ''

  onMount(() => {
    db.get('/customers.json').then(data => {
      content = data.body
      document.title = title = data.title
    })
  })
</script>

<BellyBand />
<div class="text">
  <h1>{title}</h1>
  {@html content}
</div>

<style>
  h1{
    padding: 0;
  }
  .text{
    margin: 40px 6%;
  }
</style>
